<!--suppress VueDuplicateTag -->
<script src="main.js"></script>
<template>
  <router-view v-if="isRouterAlive"></router-view>
</template>

<script>
export default {
  name: "app",
  props: ["isRouterAlive"],
};
</script>

<style src="./assets/styles/styles.scss" lang="scss"></style>
